import { RootState } from '../store';

export const isNotificationVisible = (state: RootState): boolean => state.notificationMessage.isVisible;
export const notificationMessage = (state: RootState): string => state.notificationMessage.message;
